export default {
  shoppingCartItems: state =>
    state.editOrderId ? state.orderCart?.items : state.shoppingCart?.items,
};
